import { supabase } from '@/supabase'

export const trackUserActivity = async (
  action_type: 'login' | 'credit_check_request' | 'credit_check_approval' | 'customer_checkin',
  userId: string,
  rooftopId: string,
  customerId?: number,
  metadata: Record<string, any> = {}
) => {
  try {
    await supabase
      .from('user_activity')
      .insert({
        user_id: userId,
        rooftop_id: rooftopId,
        action_type,
        customer_id: customerId,
        metadata
      });
  } catch (error) {
    console.error('Error tracking activity:', error);
  }
}; 